import { Box } from '@chakra-ui/react';

import { ListingFiltersSkeletonDesktop } from './listing-filters-skeleton-desktop';
import { ListingFiltersSkeletonMobile } from './listing-filters-skeleton-mobile';

export const ListingFiltersSkeleton = () => (
    <>
        <Box display={{ base: 'block', md: 'none' }}>
            <ListingFiltersSkeletonMobile />
        </Box>
        <Box display={{ base: 'none', md: 'block' }}>
            <ListingFiltersSkeletonDesktop />
        </Box>
    </>
);
